$(document).ready(function () {
  var interval = setInterval(function () {
    if ($(".template-product [data-loop-widget-selling-plan-group]").length > 0) {
      
      // Function to append custom elements
      function appendCustomElements() {
          // Add "per bag" after the price element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price").each(function() {
              if ($(this).find('.additional-price-text').length === 0) {
                  $(this).append('<span class="additional-price-text">Total Bag</span>');
              }
          });
  
          // Add "+ Free Accessories" after the label element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-label").each(function() {
              if ($(this).find('.subscription-label-additional-text').length === 0) {
                  $(this).append('<span class="subscription-label-additional-text">+ Free Accessories</span>');
              }
          });
  
          // Append "($1.30/serving)" using two spans after the price element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price").each(function() {
              if ($(this).next('.subscription-price-per-serving').length === 0) {
                  $(this).after('<div class="subscription-price-per-serving">(<span class="subscription-price-amount">$1.30</span><span class="price-unit">/serving</span>)</div>');
              }
          });
        }
      
        // Initial setup
        $(".custom-loop-subscription-widget").css("display", "block");
        var appendWidgetFreeProduct = $(".subscription-widget-free-product-section");
        var appendWidget = $(".custom-loop-subscription-widget-inner");
        $(".loop-widget-container").after(appendWidgetFreeProduct);
        $(".pf-product-form [data-combined]").before(appendWidget);
  
        // Initial call to ensure elements are added when the script loads
          appendCustomElements();
      
        //Upsell variant option click
        $(document).on("click",".custom-loop-subscription-widget-flavour-box-cover label",function () {
            changeVariant($(this));
        });
        
        $(document).on("click",".custom-loop-subscription-widget-quantity label",function () {
            changeVariant($(this));
        });
 
  
        function changeVariant(element) {
          setTimeout(function () {
            var variantWrapper = element.closest(".custom-loop-subscription-widget-inner");
            
             var upsellFlavourOption = variantWrapper.find(".custom-loop-subscription-widget-flavour-box-cover input:checked").data("title");
             var upsellQtyOption = variantWrapper.find(".subscribe-Save-purchase--box input:checked").data("title");
             var comb = (upsellFlavourOption + " / " + upsellQtyOption);
            var selector = "[variant-title='" + comb + "']";
  
            var selectedOptionValue = element.closest(".custom-loop-subscription-widget-inner").find(".all-variants " + selector);
            if (selectedOptionValue.length) {
              var selectedVariantPrice = selectedOptionValue.data("variant-price");
              var selectedVariantID = selectedOptionValue.data("variant-id");
            }
            $('input[name="id"]').val(selectedVariantID);
  
          // If the option is found, select it and trigger the change event
          if (selectedOptionValue.length > 0) {
              var $pfVariantSelect = $("[data-combined] .pf-variant-select");
              $pfVariantSelect.val(selectedVariantID); // Set the selected value
              $pfVariantSelect.trigger("change"); 
          }
            
          }, 100);
        }
      
      // Function to be executed when changes are detected on widget
      const handleMutations = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            appendCustomElements();
          } else if (mutation.type === 'attributes') {
            appendCustomElements();
          }
        }
      };
      
      // Create an instance of MutationObserver and pass it the callback function
      const observer = new MutationObserver(handleMutations);
      
      // Define the target node and the observer options
      const targetNode = document.querySelector('.loop-widget-container'); // Replace with your target element's ID
      const config = { 
        childList: true,     // Observe direct children
        attributes: true,    // Observe attribute changes
        subtree: true        // Observe all descendants, not just direct children
      };
      
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);


      //Start
        function toggleSubscriptionWidget() {
          if($('[data-loop-widget-selling-plan-group]').hasClass("loop-widget-purchase-option-selected")){
            $(".subscription-widget-free-product-section").show();
          }else {
            $(".subscription-widget-free-product-section").hide();
          }
        }
        toggleSubscriptionWidget();
        $(document).on("click", ".loop-widget-purchase-option", function() {
          toggleSubscriptionWidget();
        });
      //End
      clearInterval(interval);
    }
  }, 100);
});